import { Mask } from '../mask.interface';
export class AreaCodeModel implements Mask {

 private areaCodeMask = [/[0-9]/, /\d/];

  getMaskRule(): (string | RegExp)[] | Function | boolean {
    return this.areaCodeMask;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/input/rules/implementations/areaCode.model.ts